<h1 class="modal__header">View Policy</h1>
<div>
  <div class="modal__body">
    <div class="modal__text">View the policy documents for the following policies:</div>
    <div class="policy-links__row policy-links__row--top">
      <a class="text-link" (click)="exit()" href="{{ wholeLink }}" target="_blank">View Whole Life Policy</a>
    </div>
    <div class="policy-links__row policy-links__row--top">
      <a class="text-link" (click)="exit()" href="{{ termLink }}" target="_blank">View Term Life Policy</a>
      <div></div>
    </div>
  </div>
</div>
